module.exports = __webpack_public_path__ + "img/logo.d0c392aa.png";